import { render } from "./SimpleAreaChart.vue?vue&type=template&id=7dca3d2d&scoped=true"
import script from "./SimpleAreaChart.vue?vue&type=script&lang=js"
export * from "./SimpleAreaChart.vue?vue&type=script&lang=js"

import "./SimpleAreaChart.vue?vue&type=style&index=0&id=7dca3d2d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dca3d2d"]])

export default __exports__